import {Numbers} from "@/utils/Numbers";

export const AgencyFinalReportCostExporter = {

	generate(readOnlyData, costs) {
		return {
			serialNumber: readOnlyData.projectCode,
			totalMSZFunding: Numbers.methods.formatMoney(readOnlyData.totalMSZFunding),
			totalFunding: Numbers.methods.formatMoney(readOnlyData.totalFunding),
			currencyCode: readOnlyData.currencyCode,
			totalCost: this.getTotalCost(costs),
			paymentList: this.getCostList(costs),
		};
	},

	getCostList(costs) {
		let costList = [];
		costs.forEach(cost => costList.push(this.createPaymentItem(cost)));
		return costList;
	},

	getTotalCost(costs) {
		return Numbers.methods.formatMoney(costs
			.map(cost => Numbers.methods.parseToFloat(cost.value)).reduce((a, b) => a + b, 0));
	},

	createPaymentItem(cost) {
		return {
			paymentType: cost.costType,
			paymentDescription: cost.description,
			paymentDate: cost.paymentDate,
			paymentValue: Numbers.methods.formatMoney(cost.value),
		};
	},
};